<template>
  <input type="text"
    v-model="model"
    v-focus="hasFocus"
    v-mask="mask"
  >
</template>

<script>
import focusable from '@ssi/vue-common/src/mixins/focusable';

export default {
  mixins: [focusable],

  props: {
    mask: [Object, String],

    modelValue: [Number, String]
  },

  emits: ['update:modelValue'],

  computed: {
    model: {
      get: ({ modelValue }) => modelValue,

      set(newValue) {
        this.$emit('update:modelValue', newValue);
      }
    }
  }
};
</script>
